/**
 * Technical specifications reconciled with the CS-002 manual supplied16October.
 * Four educational wavelength illustrations, not four separate operating modes.
 * The mask has two combined modes. Classification and endorsements are excluded.
 */
export const wavelengths = [
  {
    id: 'blue', name: 'Blue light', wavelength: '460', unit: 'nm',
    title: 'A Different Light For Breakouts.',
    body: 'Blue light is used in light-based acne care. It is distinct from the red and near-infrared wavelengths used in skin-aging research.',
    detail: 'M2 combines the 72 blue LEDs at 460 nm with 850 nm near-infrared light.',
    color: '#94C5FF', glow: '#2D64D5', background: '#1C2942', invisible: false,
  },
  {
    id: 'red', name: 'Red light', wavelength: '665', unit: 'nm',
    title: 'Fine Lines. A Closer Look.',
    body: 'Red light is studied in skincare for the appearance of fine lines, wrinkles and rough texture.',
    detail: 'Part of M1, which combines 665, 850 and 1064 nm light.',
    color: '#FF7268', glow: '#B93135', background: '#311F25', invisible: false,
  },
  {
    id: 'near-infrared', name: 'Near-infrared', wavelength: '850', unit: 'nm',
    title: 'Beyond The Visible Spectrum.',
    body: 'Near-infrared light is invisible to the eye. It is studied alongside red light in skincare and photobiomodulation.',
    detail: 'Included in both M1 and M2. Violet identifies this invisible wavelength in the illustration.',
    color: '#C7BAFF', glow: '#7159AB', background: '#292337', invisible: true,
  },
  {
    id: '1064', name: '1064 nm laser', wavelength: '1064', unit: 'nm',
    title: 'The Fourth Wavelength.',
    body: '1064 nm is the longest of the mask’s four wavelengths. It sits in the near-infrared spectrum, alongside 850 nm.',
    detail: 'Part of M1 with 665 and 850 nm. Gold is an illustration of this invisible wavelength.',
    color: '#EAC99B', glow: '#9C6E40', background: '#302923', invisible: true,
  },
] as const;
